export const URLS = {
    FAQS: "https://support.scorza.com/hc/",
    FEEDBACK: "https://feedback.scorza.com/sso/",
    TERMSCONDITIONS: "https://scorza.com/terms-conditions",
    PRIVACYPOLICY: "https://assets.scorza.com/policies/privacy-policy.html",
    REFSIX_ACCOUNT: "https://app.scorza.com/",
    MGM_TERMS: "https://scorza.com/referral-ts-and-cs",
    SCORZA_HOME: "https://www.scorza.com",
};

export const SUPPORT_EMAIL = "support@scorza.com";

export const getScorzaHomeUrlWithTracking = () => {
    const params = new URLSearchParams({
        utm_source: "scorza-app",
        utm_medium: "app",
        utm_campaign: "auth_i_dont_have_scorza",
    });

    return `${URLS.SCORZA_HOME}?${params.toString()}`;
};
